module.exports = require('./src/normalizeWheel.js');



// WEBPACK FOOTER //
// ./~/normalize-wheel/index.js